import React from "react";
import { Text } from "./Base";
import { View } from "./View";
import makeStyles from "@mui/styles/makeStyles";
import { palette } from "../theme/palette";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: palette.blue,
    borderRadius: "50%",
    height: "1.25rem",
    width: "1.25rem",
  },
  text: {
    marginTop: "0.1rem",
    fontWeight: 500,
    color: palette.typography.white.solid,
  },
}));

const RobotDriverMarker = () => {
  const styles = useStyles();
  return (
    <View className={styles.container}>
      <Text className={styles.text}>R</Text>
    </View>
  );
};

export default RobotDriverMarker;
